/* eslint-disable no-shadow */
/* eslint-disable no-console */
import dataPodcast from '../dataPodcast.json';
import RSSParser from 'rss-parser';
import {Power1} from 'gsap';
import PodcastApi from '../components/podcast-constructor';
import AudioApi from './audio';
import helpers from '../helpers';
import announcements from './announcements';

const podcast = () => {
	const data = dataPodcast.dataPodcast;
	const list = document.querySelector('.podcasts__list');
	const audio = document.querySelector('.intro__audio');
	const reset = document.querySelector('.header__back');
	const keys = document.querySelector('.podcasts__keys');
	const about = document.querySelector('.podcasts__about');
	const name = document.querySelector('.podcasts__caption');
	const speakers = document.querySelector('.podcasts__headline');
	const imgSection = document.querySelector('.podcasts__img');
	const img = imgSection.querySelector('img');
	const time = 0.75;

	const contentReplacement = (target) => {
		const i = target.dataset.podcast;
		about.textContent = '';
		name.textContent = '';
		speakers.textContent = '';
		keys.innerHTML = data[i].keys;
		name.textContent = data[i].name;
		about.insertAdjacentHTML('afterbegin', data[i].about);
		// eslint-disable-next-line no-undef
		img.src = `${baseDir}images/podcasts/${data[i].img}`;
		data[i].spikers.forEach((el) => {
			speakers.insertAdjacentHTML('afterbegin', `<p>${el.title}</p>`);
		});
	};

	const parser = new RSSParser();

	// eslint-disable-next-line consistent-return
	const gatDATA = async () => {
		try {
			const response = await fetch('https://anchor.fm/s/56be2e08/podcast/rss');
			const convertText = await response.text();

			return await parser.parseString(convertText);
		} catch (error) {
			// console.error(error);
		}
	};

	const renderPodcasts = (reponse) => {
		reponse.forEach((el, i) => {
			const title = el.title;
			const audioLink = el.enclosure.url;
			let activeClass = '';
			if (i === 0) {
				activeClass = 'active';
			}
			const item = `
			<div class="podcasts__item ${activeClass}" data-podcast="${i}"  data-podcasts__name="${title}"  data-podcast="${i}" data-player="pause">
			<div class="podcasts__item--section">
				<div class="podcasts__name">${title}</div>
				<button class="podcasts__btn" type="button" data-player="pause" data-name="${title}">
					<svg class="podcasts__play">
						<use xlink:href="/images/sprites.svg#play"></use>
					</svg>
					<svg class="podcasts__pause">
						<use xlink:href="/images/sprites.svg#pause"></use>
					</svg>
				</button>
			</div>
			<div class="podcasts__progress">
				<svg width="566" height="6" viewBox="0 0 566 6" fill="none" xmlns="http://www.w3.org/2000/svg">
					<line y1="5" x2="566" y2="5" stroke="currentColor" stroke-width="2"></line>
					<rect width="0" height="6" fill="#A42261"></rect>
				</svg>
			</div><audio class="podcasts__audio" src="${audioLink}"></audio></div>`;
			list.insertAdjacentHTML('beforeend', `${item}`);
		});
	};
	const sidebar = document.querySelectorAll('.intro__sidebar.for-mobile .audio');
	const relatedItem = document.querySelectorAll('.related__item .audio');
	const renderAudio = (reponse) => {
		const initialSlideChange = window.location.pathname.slice(1);
		$('.intro__audio .player').detach();
		reponse.forEach((el, i) => {
			const title = el.title;
			const audioLink = el.enclosure.url;
			let activeClass = '';

			// грязная помойка
			let index = i;

			index = i - 1;

			if (index < 0) {
				index = reponse.length - 1;
			}

			if (index === +initialSlideChange) {
				activeClass = 'active';
			}

			const item = `<button class="player btn ${activeClass}" type="button" data-index="${index}" data-player="pause" data-name="${title}">
			<svg class="player__play">
				<use xlink:href="/images/sprites.svg#play"></use>
			</svg>
			<svg class="player__pause">
				<use xlink:href="/images/sprites.svg#pause"></use>
			</svg>
			<svg class="player__circle" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="30" cy="30" r="28" fill="none" stroke-dasharray="0 185" stroke-dashoffset="0"></circle>
			</svg>
			<audio class="player__audio" src="${audioLink}"></audio>
			</button>`;

			audio.insertAdjacentHTML('beforeend', `${item}`);
			relatedItem[index].insertAdjacentHTML('beforeend', `${item}`);
			sidebar[index].insertAdjacentHTML('beforeend', `${item}`);
		});
	};

	gatDATA().then((res) => {
		renderPodcasts(res.items);
		renderAudio(res.items);
		const podcasts = document.querySelectorAll('.podcasts__item');
		const firstItem = document.querySelector('[data-podcast="0"]');
		const player = document.querySelectorAll('.player');

		podcasts.forEach((element) => {
			let pod = new PodcastApi(element);
			pod.init();
			reset.addEventListener('click', () => {
				pod.reset();
				element.classList.remove('active');
				firstItem.classList.add('active');
				contentReplacement(firstItem);
			});
		});

		player.forEach((element) => {
			const audio = new AudioApi(element);
			audio.init();
		});
		announcements.cliclEvent();
	});

	const actionPodcast = (element) => {
		const podcasts = document.querySelectorAll('.podcasts__item');
		const target = element;
		if (!target.classList.contains('active')) {
			gsap.fromTo([keys, about, img, speakers, name], time, {
				alpha: 0,
				ease: Power1.linear,
				onComplete() {
					contentReplacement(target);
				},
			}, {
				alpha: 1,
				delay: time / 2,
				ease: Power1.linear,
				clearProps: 'all',

			});
		}
		podcasts.forEach((el) => {
			el.classList.remove('active');
		});

		target.classList.add('active');
	};
	list.addEventListener('click', () => {
		const target = event.target;
		const item = target.closest('.podcasts__item');
		if (target.closest('.podcasts__item')) {
			actionPodcast(item);
		}
	});
};

export {podcast};
